/**
 * gi-countdown.js
 *
 * Honest flash-sale countdown. It counts down to a single fixed moment
 * (Theme settings → Flash Sale Countdown → "Sale end date & time (UTC)").
 *
 * - The deadline lives in the theme setting, not in the browser, so a page
 *   refresh always shows the correct remaining time — it never jumps back
 *   up to the full duration.
 * - Once the deadline passes, the widget hides itself and stays hidden.
 *   It does NOT reset to a new countdown on its own. To run another flash
 *   sale, set a new future date/time in the theme setting.
 * - This script only controls whether the countdown badge is shown. The
 *   price numbers themselves always come straight from the live Shopify
 *   product data (see gi-price-block.liquid / gi-hero.liquid), so they're
 *   never out of sync with what's actually charged at checkout.
 */
(function () {
  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function tick(el) {
    var raw = el.getAttribute("data-end") || "";
    if (!raw) return false;
    // Stored as "YYYY-MM-DD HH:MM" in UTC — the "Z" makes that explicit.
    var end = new Date(raw.replace(" ", "T") + "Z").getTime();
    if (isNaN(end)) return false;

    var diff = end - Date.now();
    if (diff <= 0) {
      el.style.display = "none";
      return false;
    }

    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    var dEl = el.querySelector("[data-cd-d]");
    var hEl = el.querySelector("[data-cd-h]");
    var mEl = el.querySelector("[data-cd-m]");
    var sEl = el.querySelector("[data-cd-s]");
    if (dEl) dEl.textContent = pad(d);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
    return true;
  }

  function init() {
    var widgets = document.querySelectorAll(".fs-cd[data-end]");
    if (!widgets.length) return;
    widgets.forEach(function (el) {
      if (!tick(el)) return; // already expired or invalid — stay hidden
      var iv = setInterval(function () {
        if (!tick(el)) clearInterval(iv);
      }, 1000);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
